
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/curioed",
      function () {
        return require("private-next-pages/case-study/curioed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/curioed"])
      });
    }
  